<template>
    <v-container fluid class="page-profilo">

        <!-- <div>
            <v-btn small dense @click="indietro()">
                <v-icon color="primary">mdi-keyboard-backspace</v-icon>
                Indietro
            </v-btn>
        </div> -->

        <!-- Header -->
        <div class="page-header">
            <div class="header-title">
                <v-icon color="primary">mdi-account-cog-outline</v-icon>
                <h1>Profilo</h1>
            </div>
        </div>

        <v-card class="profilo-card elevation-2">
            <!-- Tabs -->
            <v-tabs v-model="tab" color="primary">
                <v-tab value="utente">Utente</v-tab>
                <v-tab value="azienda">Azienda</v-tab>
                <v-tab value="api" v-if="role !== 2">API</v-tab>
            </v-tabs>

            <v-divider />

            <v-window v-model="tab">

                <!-- TAB UTENTE -->
                <v-window-item value="utente">
                    <v-card-text>

                        <v-row>

                            <v-col cols="12" md="6">
                                <v-text-field label="Username" v-model="utente.username" readonly variant="outlined"
                                    density="comfortable" />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field label="Email" v-model="utente.email" variant="outlined"
                                    density="comfortable" />
                            </v-col>

                        </v-row>

                        <div class="d-flex justify-end">
                            <v-btn color="primary" :loading="loadingSalvaUtente" @click="salvaUtente">
                                Salva
                            </v-btn>
                        </div>

                        <v-divider class="my-4" />

                        <h3 class="section-title mb-4">Cambio password</h3>

                        <v-row>

                            <v-col cols="12" md="4">
                                <v-text-field label="Password attuale" v-model="password.old"
                                    :type="showPass ? 'text' : 'password'" variant="outlined" density="comfortable"
                                    :append-inner-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append-inner="showPass = !showPass" />
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field label="Nuova password" v-model="password.new"
                                    :type="showPass ? 'text' : 'password'" variant="outlined" density="comfortable" />
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field label="Conferma password" v-model="password.confirm"
                                    :type="showPass ? 'text' : 'password'" variant="outlined" density="comfortable"
                                    :error-messages="passwordMismatch ? 'Le password non coincidono' : ''" />
                            </v-col>

                        </v-row>

                        <v-btn color="primary" :loading="loadingPassword" :disabled="passwordMismatch"
                            @click="cambiaPassword">
                            Aggiorna password
                        </v-btn>

                    </v-card-text>
                </v-window-item>


                <!-- TAB AZIENDA -->
                <v-window-item value="azienda">
                    <v-card-text>

                        <v-row>

                            <v-col cols="12" md="6">
                                <v-text-field label="Ragione sociale" v-model="azienda.ragioneSociale" readonly
                                    variant="outlined" density="comfortable" />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field label="Partita IVA" v-model="azienda.pIva" readonly variant="outlined"
                                    density="comfortable" />
                            </v-col>

                        </v-row>

                    </v-card-text>
                </v-window-item>


                <!-- TAB API -->
                <v-window-item value="api">
                    <v-card-text>

                        <div v-if="apiKey">

                            <v-text-field label="API Key" :type="showApi ? 'text' : 'password'" :model-value="apiKey"
                                readonly variant="outlined" density="comfortable">

                                <template #append-inner>

                                    <v-btn icon variant="text" @click="showApi = !showApi">
                                        <v-icon>
                                            {{ showApi ? 'mdi-eye-off' : 'mdi-eye' }}
                                        </v-icon>
                                    </v-btn>

                                    <v-btn icon variant="text" @click="copiaApi">
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>

                                </template>

                            </v-text-field>

                            <!-- <div class="d-flex align-center gap-3">
                                <v-btn variant="tonal" color="warning" :loading="loadingRigenera" @click="rigeneraApi">
                                    Rigenera API Key
                                </v-btn>

                                <v-btn variant="tonal" color="error" :loading="loadingToggleApi" @click="disabilitaApi">
                                    Disabilita API
                                </v-btn>
                            </div> -->

                        </div>


                        <div v-else class="api-disabled">

                            <v-icon size="36" class="mb-2 text-grey">
                                mdi-api-off
                            </v-icon>

                            <p class="text-body-2 text-medium-emphasis">
                                Le API non sono abilitate per questo account.
                            </p>

                            <v-btn color="primary" prepend-icon="mdi-api" :loading="loadingToggleApi"
                                @click="abilitaApi">
                                Abilita API
                            </v-btn>

                        </div>

                    </v-card-text>
                </v-window-item>

            </v-window>

        </v-card>

        <!-- Snackbar feedback -->
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" location="bottom right" :timeout="3000">
            {{ snackbar.text }}
        </v-snackbar>

    </v-container>
</template>


<script>
import { ref, computed, onMounted } from "vue"
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import {
    get_dati_utente,
    aggiorna_dati_utente,
    cambia_password,
    rigenera_api_key,
    toggle_api_key
} from "@/api/api.profilo"

export default {

    name: "ProfiloUtente",

    setup() {
        const store = useStore();

        const router = useRouter()
        const tab = ref("utente")

        const role = computed(() => store.getters["user/getRole"]);

        const utente = ref({
            username: "",
            email: ""
        })

        const azienda = ref({
            ragioneSociale: "",
            pIva: ""
        })

        const apiKey = ref(null)

        const showApi = ref(false)
        const showPass = ref(false)

        const password = ref({
            old: "",
            new: "",
            confirm: ""
        })

        const loadingSalvaUtente = ref(false)
        const loadingPassword = ref(false)
        const loadingRigenera = ref(false)
        const loadingToggleApi = ref(false)

        const snackbar = ref({
            show: false,
            text: "",
            color: "success"
        })

        const passwordMismatch = computed(() =>
            password.value.confirm !== "" && password.value.new !== password.value.confirm
        )

        const notify = (text, color = "success") => {
            snackbar.value = { show: true, text, color }
        }


        const load = async () => {
            try {
                let res = await get_dati_utente()
                utente.value = res.data.utente
                azienda.value = res.data.azienda
                apiKey.value = res.data.apiKey ?? null
            } catch {
                notify("Errore nel caricamento del profilo.", "error")
            }
        }

        const salvaUtente = async () => {
            loadingSalvaUtente.value = true
            try {
                await aggiorna_dati_utente({
                    username: utente.value.username,
                    email: utente.value.email
                })
                notify("Dati aggiornati con successo.")
            } catch {
                notify("Errore durante il salvataggio.", "error")
            } finally {
                loadingSalvaUtente.value = false
            }
        }

        const copiaApi = () => {
            navigator.clipboard.writeText(apiKey.value)
            notify("API Key copiata negli appunti.")
        }

        const abilitaApi = async () => {
            loadingToggleApi.value = true
            try {
                await toggle_api_key(true)
                await load()
                notify("API abilitate.")
            } catch {
                notify("Errore durante l'abilitazione delle API.", "error")
            } finally {
                loadingToggleApi.value = false
            }
        }

        const disabilitaApi = async () => {
            loadingToggleApi.value = true
            try {
                await toggle_api_key(false)
                apiKey.value = null
                notify("API disabilitate.")
            } catch {
                notify("Errore durante la disabilitazione delle API.", "error")
            } finally {
                loadingToggleApi.value = false
            }
        }

        const rigeneraApi = async () => {
            loadingRigenera.value = true
            try {
                const res = await rigenera_api_key()
                apiKey.value = res.data.apiKey
                notify("API Key rigenerata.")
            } catch {
                notify("Errore durante la rigenerazione.", "error")
            } finally {
                loadingRigenera.value = false
            }
        }

        const cambiaPassword = async () => {
            if (passwordMismatch.value) return

            loadingPassword.value = true
            try {
                await cambia_password({
                    old: password.value.old,
                    new: password.value.new,
                    confirm: password.value.confirm
                })
                password.value = { old: "", new: "", confirm: "" }
                notify("Password aggiornata con successo.")
            } catch (err) {
                const msg = err?.response?.status === 400
                    ? "Password attuale non corretta."
                    : "Errore durante l'aggiornamento della password."
                notify(msg, "error")
            } finally {
                loadingPassword.value = false
            }
        }

        const indietro = () => {
            router.push('/');
        }


        onMounted(load)

        return {
            role,
            tab,
            utente,
            azienda,
            apiKey,
            password,
            showApi,
            showPass,
            snackbar,
            loadingSalvaUtente,
            loadingPassword,
            loadingRigenera,
            loadingToggleApi,
            passwordMismatch,
            copiaApi,
            salvaUtente,
            abilitaApi,
            disabilitaApi,
            rigeneraApi,
            cambiaPassword,
            indietro
        }

    }

}
</script>


<style scoped>
.page-profilo {
    max-width: 900px;
    margin: auto;
}

.page-header {
    margin-bottom: 16px;
}

.header-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.header-title h1 {
    font-size: 20px;
    font-weight: 600;
}

.profilo-card {
    border-radius: 10px;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
}

.api-disabled {
    text-align: center;
    padding: 30px;
}
</style>